import React, { useContext } from "react";
import axios from 'axios';
import {
  Divider,
  Grid,
  Typography,
  Accordion,
  TextField,
  MenuItem,
  AccordionSummary,
  AccordionDetails,
  Button,
  Tooltip,
  IconButton,
  SvgIcon
} from "@material-ui/core";

import InfoTooltip from "../general/InfoTooltip";
import CustomerPortalDialog from "./tools/CustomerPortalDialog";
import { PageContext } from "../../contexts/PageContext";
import { UserContext } from "../../contexts/UserContext";


import InfoIcon from '@material-ui/icons/Info';
import ContentPasteGoIcon from '@mui/icons-material/ContentPasteGo';


export default function CreditFieldGroupPerson(
  {
    renderCreditField,
    creditFunctions,
    createPortal,
    savePortal,
    portals,
    index,
    credit_id,
    metafields,
    setMetafields,
    isOnlyPerson
  }) {
  const pageContext = useContext(PageContext);
  const userContext = useContext(UserContext);

  const copyAdress = (fromIndex, toIndex) => {
    const fromFields = [
      "__person" + fromIndex + "__postleitzahl",
      "__person" + fromIndex + "__ort",
      "__person" + fromIndex + "__strasse",
      "__person" + fromIndex + "__hausnummer",
    ];


    setMetafields(fields => {
      fields.forEach((metafield) => {
        if (fromFields.includes(metafield.meta_key)) {
          let value = creditFunctions.getFirstValueByMetaKey(metafield.meta_key);
          const newMetaKey = metafield.meta_key.replace("__person" + fromIndex + "__", "__person" + toIndex + "__");
          // find the metafield with the new meta key
          const newMetafield = fields.find((field) => field.meta_key === newMetaKey);
          if (newMetafield) {
            // set the value of the new metafield
            fields = creditFunctions.setMetafieldValue(fields, newMetafield, value);
          }
        }
      });
      return [...fields];
    });

  };

  const maybeDeletePerson = () => {
    pageContext.setConfirmDialog({
      open: true,
      title: "Wirklich löschen?",
      message:
        "Bist du dir sicher, dass du die Person löschen möchtest?",
      handleYes: () => {
        if (!portals || portals.length == 0) {
          deletePerson(index);
        } else {
          const portal = portals.find((portal) => portal.person_index == index);
          if (!portal) {
            deletePerson(index);
          } else {
            let url = `${process.env.REACT_APP_API_SERVICE_URL}/signatures/${credit_id}`;
            const options = {
              url: url,
              method: 'get',
              headers: userContext.getRequestAuthHeader()
            };
            axios(options)
              .then((res) => {
                const signatures = res.data;
                // check is signatures is array and has length
                if (!Array.isArray(signatures) || signatures.length === 0) {
                  deletePerson(index);
                } else {
                  let hasSignatures = false;
                  console.log(signatures);
                  signatures.forEach((signature) => {
                    if (signature.portal_id == portal.id) {
                      hasSignatures = true;
                    }
                  });
                  if (hasSignatures) {
                    pageContext.setErrorMessage("Bitte lösche zuerst die Unterschriften aus dem Kundenportal und lösche danach die Person.");
                  } else {
                    deletePortal(portal.id, {
                      callBack: () => {
                        deletePerson(index);
                      }
                    });
                  }
                }
              })
              .catch((err) => {
                console.log(err);
              });
          }
        }

        pageContext.setConfirmDialog({
          open: false,
        });
      },
      handleNo: () => {
        pageContext.setConfirmDialog({
          open: false,
        });
      },
    });
  }

  const deletePortal = (portal_id, { callBack }) => {
    const options = {
      url: `${process.env.REACT_APP_API_SERVICE_URL}/customerportal/${credit_id}/${portal_id}`,
      method: 'delete',
      headers: userContext.getRequestAuthHeader()
    };
    axios(options)
      .then((res) => {
        if (callBack) {
          callBack();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const deletePerson = (deleteIndex) => {
    // Die Übertragung zur Bank ist immer auf die KN bezogen, daher resetten wir die externen IDs damit diese neu übertragen werden müssen.
    if (deleteIndex === index) {
      creditFunctions.resetExternalCreditIds();
    }

    const nextPersonPortal = portals.find((portal) => portal.person_index == (deleteIndex + 1));
    // falls die nächste Person ein Portal hat wird es hier her verschoben
    // so wie die restlichen Metafields dieser Person hier her verschoben werden
    if (nextPersonPortal) {
      const newPortal = {
        id: nextPersonPortal.id,
      };
      newPortal.person_index = deleteIndex;
      savePortal(newPortal, () => { });
    }

    setMetafields(fields => {
      fields.forEach((metafield) => {
        if (metafield.meta_key.startsWith("__person" + deleteIndex + "__")) {
          if (metafield.meta_key !== "__person1__in_berechnung_beruecksichtigen") {
            let value = null;
            if (deleteIndex < 4) {
              value = creditFunctions.getFirstValueByMetaKey(metafield.meta_key.replace("__person" + deleteIndex + "__", "__person" + (deleteIndex + 1) + "__"));
            }
            fields = creditFunctions.setMetafieldValue(fields, metafield, value);
          }
        }
      });
      return fields;
    });

    if (deleteIndex < 4) {
      // reset next person after copying values to current person
      deletePerson(deleteIndex + 1);
    }
  }


  return (
    <>
      {/*renderCreditField("__person" + index + "__vertragsabschluss_auf_eigene_rechnung", 12, 6)*/}
      {renderCreditField("__person" + index + "__im_gemeinsamen_haushalt", 12, 5)}
      {renderCreditField("__person" + index + "__in_berechnung_beruecksichtigen", 12, 4)}
      {!isOnlyPerson &&
        <Grid item xs={12} md={index == 1 ? 12 : 3} align="right">
          <Button
            variant="text"
            onClick={() => {
              maybeDeletePerson();
            }}
          >
            Kreditnehmer löschen
          </Button>
        </Grid>
      }

      <Grid item xs={12} md={12}>
        <Divider />
      </Grid>
      {renderCreditField("__person" + index + "__anrede", 6, 2)}
      {renderCreditField("__person" + index + "__vorname", 6, 4)}
      {renderCreditField("__person" + index + "__nachname", 6, 4)}
      {renderCreditField("__person" + index + "__titel", 6, 2)}
      {renderCreditField("__person" + index + "__postleitzahl", 4, 2)}
      {renderCreditField("__person" + index + "__ort", 8, 4)}
      {renderCreditField("__person" + index + "__strasse", 8, 4)}
      {renderCreditField("__person" + index + "__hausnummer", 4, 2)}
      {/* ein anderes Land als Österreich würde zu einer Absage führen */}
      <Grid item xs={12} md={3}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={12}>
            <TextField
              fullWidth
              label="Land"
              value="AT"
              InputLabelProps={{ shrink: true }}
              select
              disabled
            >
              <MenuItem value="AT">Österreich</MenuItem>
            </TextField>
            <InfoTooltip
              variant="small"
              content="ein anderes Land als Österreich würde zu einer Absage führen"
            />
          </Grid>
        </Grid>
      </Grid>
      {index == 2 &&
        <Grid item xs={12} md={9}>
          <Button
            variant="text"
            onClick={() => {
              copyAdress(1, 2);
            }}
          >
            Adresse von Kreditnehmer 1 kopieren
          </Button>
        </Grid>
      }
      {index == 4 &&
        <Grid item xs={12} md={9}>
          <Button
            variant="text"
            onClick={() => {
              copyAdress(3, 4);
            }}
          >
            Adresse von Kreditnehmer 3 kopieren
          </Button>
        </Grid>
      }
      <Grid item xs={12} md={12}>
        <Divider />
      </Grid>
      {renderCreditField("__person" + index + "__kontakt_mobil", 5, 2)}
      <Grid item xs={2} md={1}>
        <Tooltip title="Übernehmen">
          <IconButton
            color="secondary"
            onClick={() => {
              const kontakt_mobil = creditFunctions.getFirstValueByMetaKey("__person" + index + "__kontakt_mobil") || "";
              setMetafields(fields => {
                const newMetafield = fields.find((field) => field.meta_key === "__person" + index + "__kontakt_telefon");
                if (newMetafield) {
                  // set the value of the new metafield
                  fields = creditFunctions.setMetafieldValue(fields, newMetafield, kontakt_mobil);
                }
                return [...fields];
              });
            }}
          >
            <ContentPasteGoIcon />
          </IconButton>
        </Tooltip>
      </Grid>
      {renderCreditField("__person" + index + "__kontakt_telefon", 5, 2)}
      {renderCreditField("__person" + index + "__kontakt_email", 12, 3)}
      <Grid item xs={12} md={3}>
        <CustomerPortalDialog
          personIndex={index}
          creditFunctions={creditFunctions}
          createPortal={createPortal}
          savePortal={savePortal}
          portals={portals}
          credit_id={credit_id}
          metafields={metafields}
          setMetafields={setMetafields}
        />
      </Grid>
      <Grid item xs={12} md={12}>
        <Divider />
      </Grid>
      {renderCreditField("__person" + index + "__bankaustria_customer_id", 12, 12, 'bankaustriacustomer')}
      {renderCreditField("__person" + index + "__geburtsdatum", 6, 3)}
      {renderCreditField("__person" + index + "__geburtsland", 6, 3)}
      {renderCreditField("__person" + index + "__geburtsland_sonstiges", 6, 3)}
      {renderCreditField("__person" + index + "__geburtsort", 6, 3)}
      {/*renderCreditField("__person" + index + "__svnr", 6, 3)*/}
      {renderCreditField("__person" + index + "__familienstand", 6, 3)}
      {renderCreditField("__person" + index + "__gueterstand", 6, 3)}
      {renderCreditField("__person" + index + "__nationalitaet", 6, 3)}


      <Grid item xs={12} md={12}>
        <Divider />
      </Grid>
      {renderCreditField("__person" + index + "__pkw_besitz", 12, 6)}
      {renderCreditField("__person" + index + "__insolvenzverfahren_letzte_5j", 12, 6)}
      {renderCreditField("__person" + index + "__inkassozahlungen_oder_mahnungen_letzte_6m", 12, 6)}
      <Grid item xs={12} md={12}>
        <Divider />
      </Grid>
      {renderCreditField("__person" + index + "__bankverbindung", 12, 6)}
      {renderCreditField("__person" + index + "__bank_austria_status", 12, 6)}
      {renderCreditField("__person" + index + "__bankverbindung_sonstiges", 12, 6)}


      <Grid item xs={12} md={12}>
        <Divider />
      </Grid>
      {renderCreditField("__person" + index + "__aktueller_wohnstatus", 12, 6)}
      {renderCreditField("__person" + index + "__housingtype", 12, 6)}
      {renderCreditField("__person" + index + "__wohnhaft_seit", 6, 4)}
      {renderCreditField("__person" + index + "__zukuenftiger_wohnstatus", 6, 4)}
      <Grid item xs={12} md={12}>

      </Grid>
      {renderCreditField("__person" + index + "__anzahl_personen_im_haushalt", 12, 4)}
      {renderCreditField("__person" + index + "__anzahl_unterhaltsberechtigte_kinder", 12, 4)}
      {renderCreditField("__person" + index + "__anzahl_unterhaltsberechtigte_personen", 12, 4)}
      {renderCreditField("__person" + index + "__alter_kind1", 6, 3)}
      {renderCreditField("__person" + index + "__alter_kind2", 6, 3)}
      {renderCreditField("__person" + index + "__alter_kind3", 6, 3)}
      {renderCreditField("__person" + index + "__alter_kind4", 6, 3)}
      {renderCreditField("__person" + index + "__alter_kind5", 6, 3)}
      <Grid item xs={12} md={12}>
        <Divider />
      </Grid>
      {renderCreditField("__person" + index + "__beruflicher_status", 6, 3)}
      {renderCreditField("__person" + index + "__branche", 12, 6)}
      {/*renderCreditField("__person" + index + "__erwerbstaetig_in", 6, 3 )*/}
      {/* ein anderes Land als Österreich würde zu einer Absage führen */}
      <Grid item xs={12} md={3}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={12}>
            <TextField
              fullWidth
              label="Erwerbstätig in"
              value="AT"
              InputLabelProps={{ shrink: true }}
              select
              disabled
            >
              <MenuItem value="AT">Österreich</MenuItem>
            </TextField>
            <InfoTooltip
              variant="small"
              content="ein anderes Land als Österreich würde zu einer Absage führen"
            />
          </Grid>
        </Grid>
      </Grid>
      {renderCreditField("__person" + index + "__beruf", 6, 3)}
      {renderCreditField("__person" + index + "__beschaeftigt_seit", 6, 3)}
      {renderCreditField("__person" + index + "__pensionsantritt", 6, 3)}
      {renderCreditField("__person" + index + "__ausbildung", 6, 3)}
      {renderCreditField("__person" + index + "__previous_employment_duration", 12, 9, "months")}
      <Grid item xs={12} md={12}>
      </Grid>
      {renderCreditField("__person" + index + "__career1_from", 6, 2)}
      {renderCreditField("__person" + index + "__career1_to", 6, 2)}
      {renderCreditField("__person" + index + "__career1_work", 6, 3)}
      {renderCreditField("__person" + index + "__career1_branch", 6, 2)}
      {renderCreditField("__person" + index + "__career1_notes", 12, 3)}
      {renderCreditField("__person" + index + "__career2_from", 6, 2)}
      {renderCreditField("__person" + index + "__career2_to", 6, 2)}
      {renderCreditField("__person" + index + "__career2_work", 6, 3)}
      {renderCreditField("__person" + index + "__career2_branch", 6, 2)}
      {renderCreditField("__person" + index + "__career2_notes", 12, 3)}
      {renderCreditField("__person" + index + "__career3_from", 6, 2)}
      {renderCreditField("__person" + index + "__career3_to", 6, 2)}
      {renderCreditField("__person" + index + "__career3_work", 6, 3)}
      {renderCreditField("__person" + index + "__career3_branch", 6, 2)}
      {renderCreditField("__person" + index + "__career3_notes", 12, 3)}
      {renderCreditField("__person" + index + "__career4_from", 6, 2)}
      {renderCreditField("__person" + index + "__career4_to", 6, 2)}
      {renderCreditField("__person" + index + "__career4_work", 6, 3)}
      {renderCreditField("__person" + index + "__career4_branch", 6, 2)}
      {renderCreditField("__person" + index + "__career4_notes", 12, 3)}
      <Grid item xs={12} md={12}>
        <Divider />
      </Grid>
      {renderCreditField("__person" + index + "__arbeitgeber_name", 12, 4)}
      {renderCreditField("__person" + index + "__arbeitgeber_plz", 4, 1)}
      {renderCreditField("__person" + index + "__arbeitgeber_ort", 8, 3)}
      {renderCreditField("__person" + index + "__arbeitgeber_strasse", 8, 3)}
      {renderCreditField("__person" + index + "__arbeitgeber_hausnummer", 4, 1)}
      <Grid item xs={12} md={12}>
        <Divider />
      </Grid>
      <Grid item xs={12} md={12}>
        <Accordion>
          <AccordionSummary
            expandIcon={<InfoIcon />}
          >
            <Typography>Berechnung des Einkommens</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <div>
              <Typography gutterBottom>Durchschnittliches monatliches Nettoeinkommen auf Basis der beiden niedrigsten Bezüge aus den letzten 3 Monate (Gehalt, Lohn, Alterspension, unbefristete Invaliditäts-/Berufsunfähigkeits-/Witwenpensionen, Pensionsvorschüsse sowie Pensionen aus Deutschland, wenn es sich um Deviseninländer handelt)<br />jeweils gemäß Einkommensnachweis (exklusive Sonderzahlung sowie exklusive Ausgleichszulage und Pflegegeld)</Typography>
              <Typography gutterBottom>Bei <strong>Saisonarbeitern</strong> (Unterbrechung Dienstverhältnis länger als 1 Monat im Jahr) ist das so ermittelte monatliche Nettoeinkommen reduziert auf Basis 9 Monate zu erfassen (x 9 / 12)</Typography>
              <Typography gutterBottom>Mindestens € 943,00 bei EINEM Dienstgeber (geringer oder Karenzgeld nur bei Ehepartner/Lebensgefährten im gleichen Haushalt als 2. Kreditnehmer bei Hypothekarkrediten erlaubt)</Typography>
              <Typography gutterBottom>Bei <strong>freien Dienstnehmern oder Werkverträgen</strong> ist das steuerpflichtige Einkommen laut Einkommenssteuerbescheid (nicht älter als 24 Monate) abzüglich der festgesetzten Einkommenssteuer durch 12 zu dividieren.</Typography>
              <Typography variant="h5">Trinkgelder</Typography>
              <Typography>
                (kein Nachweis erforderlich) in Höhe von max. 10 % des monatlichen Nettoeinkommens ausschließlich für Beschäftigte in folgenden Branchen:
              </Typography>
              <ul>
                <li>Hotel- und Gastgewerbe</li>
                <li>Friseure</li>
                <li>Kosmetik- und Massagesalons</li>
                <li>angestellte Taxifahrer</li>
              </ul>
              <Typography gutterBottom>
                erlaubt und sind als sonstige Bezüge zu erfassen (Vermerk am Gehaltszettel). Bei sämtlichen nicht angeführten Branchen ist der Ansatz eines Trinkgeldes untersagt.
              </Typography>
              <Typography variant="h5">Sonstige Bezüge</Typography>
              <Typography>
                Sonstige nachgewiesene, regelmäßige und dauerhafte monatliche Einnahmen, darunter fallen
              </Typography>
              <ul>
                <li>Mieteinnahmen</li>
                <li>Leibrente</li>
                <li>Unterhalt für Kreditnehmer (nicht für Kinder!)</li>
                <li>Nebeneinkünfte (ZeichenB. Pensionszahlungen aus Versicherungsverträgen)</li>
              </ul>
              <Typography>
                Nicht erlaubt als sonstige monatliche Einnahmen sind:
              </Typography>
              <ul>
                <li>Stipendien</li>
                <li>Ausgleichzulagen</li>
                <li>Pflegegelder</li>
                <li>Waisenpensionen</li>
                <li>Krankengeld</li>
                <li>Kinderbetreuungs- (Karenz)geld</li>
                <li>Förderungen/Wohnbeihilfen</li>
                <li>Arbeitslosengeld</li>
                <li>Notstandshilfe</li>
                <li>Wohngeld</li>
                <li>Versicherungsleistungen aus Verdienstentgang</li>
                <li>Aufwands- oder Lehrlingsentschädigungen</li>
                <li>Gratifikationen</li>
                <li>Dividenden</li>
                <li>Jahres- und Treueprämie</li>
                <li>oder ähnliches...</li>
              </ul>
            </div>
          </AccordionDetails>
        </Accordion>
      </Grid>

      {renderCreditField("__person" + index + "__monatliches_nettoeinkommen", 12, 7, "pricetable")}
      {renderCreditField("__person" + index + "__monatliches_nettoeinkommen_anzahl", 12, 5, "label_before")}
      {renderCreditField("__person" + index + "__monatliches_nettoeinkommen_ehepartner", 12, 7, "pricetable")}
      {renderCreditField("__person" + index + "__sonstige_bezuege", 12, 7, "pricetable")}
      {renderCreditField("__person" + index + "__anmerkung_sonstige_bezuege", 12, 5, "multiline")}
      {renderCreditField("__person" + index + "__alimente_in_sonstigen_einkuenften_enthalten", 12, 7)}
      {renderCreditField("__person" + index + "__anmerkung_alimente", 12, 5, "multiline")}
      {renderCreditField("__person" + index + "__sonstige_bezuege_nicht_nachgewiesen", 12, 7, "pricetable")}
      <Grid item xs={12} md={12}>
        <Divider />
      </Grid>
      {renderCreditField("__person" + index + "__ausgaben_derzeitige_wohnkosten", 12, 7, "pricetable")}
      {renderCreditField("__person" + index + "__werden_diese_nach_der_finanzierung_entfallen", 12, 5)}
      <Grid item xs={12} md={12}>
        <Typography variant="h5">Ausgaben</Typography>
        <Typography>Diese Ausgaben betreffen immer die zukünftige Wohnsituation.</Typography>
      </Grid>
      {renderCreditField("__person" + index + "__ausgaben_lebenshaltungskosten", 12, 7, "pricetable")}
      {renderCreditField("__person" + index + "__gesonderte_ausgaben_kinder", 12, 7, "pricetable")}
      {renderCreditField("__person" + index + "__ausgaben_alimente", 12, 7, "pricetable")}
      {renderCreditField("__person" + index + "__ausgaben_sonst_verpflichtungen", 12, 7, "pricetable")}
      {renderCreditField("__person" + index + "__ausgaben_tv", 12, 7, "pricetable")}
      {renderCreditField("__person" + index + "__ausgaben_telefon_internet", 12, 7, "pricetable")}
      {renderCreditField("__person" + index + "__ausgaben_kfz", 12, 7, "pricetable")}
      {renderCreditField("__person" + index + "__anzahl_pkw_im_haushalt", 12, 5, "pricetable_without_currency")}
      {renderCreditField("__person" + index + "__ausgaben_sonstige_mobilitaet", 12, 7, "pricetable")}
      {renderCreditField("__person" + index + "__ausgaben_betriebskosten_miete", 12, 7, "pricetable")}
      {renderCreditField("__person" + index + "__ausgaben_energiekosten", 12, 7, "pricetable")}
      {renderCreditField("__person" + index + "__ausgaben_wohnkosten_nachgewiesen", 12, 5)}
      {/*parseInt(creditFunctions.getFirstValueByMetaKey("__person" + index + "__ausgaben_energiekosten")) + parseInt(creditFunctions.getFirstValueByMetaKey("__person" + index + "__ausgaben_betriebskosten_miete")) < 430 &&
        <>
          { renderCreditField("__person" + index + "__ausgaben_wohnkosten_nachgewiesen", 12, 5)}
        </>
      */}
      {renderCreditField("__person" + index + "__ausgaben_berufsunfaehigkeitsversicherungen", 12, 7, "pricetable")}
      {renderCreditField("__person" + index + "__ausgaben_unfallversicherungen", 12, 7, "pricetable")}
      {renderCreditField("__person" + index + "__ausgaben_versicherungen", 12, 7, "pricetable")}
      <Grid item xs={12} md={12}>
        <Typography variant="h5">Rückzahlung</Typography>
      </Grid>
      {renderCreditField("__person" + index + "__rueckzahlung_iban", 12, 4, "iban")}
      {renderCreditField("__person" + index + "__rueckzahlung_bic", 12, 3)}
    </>
  );
}
